import { NgModule } from '@angular/core';

import { ApmErrorLogger } from './apm-error-logger.service';
import { BasicErrorLogger } from './basic-error-logger.service';
import { ErrorLogger } from './error-logger';
import { ErrorLoggerService } from './error-logger.service';

@NgModule({
    providers: [
        ErrorLoggerService,
        { provide: ErrorLogger, useClass: ErrorLoggerService, multi: true },
        { provide: ErrorLogger, useClass: BasicErrorLogger, multi: true },
        { provide: ErrorLogger, useClass: ApmErrorLogger, multi: true },
    ],
})
export class ErrorHandlingModule {}
